/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPayee401kRate.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/payee-401k-rate";

export class AutogenModelPayee401kRate<RowType extends ModelRow> extends Endpoint<RowType, RowPayee401kRateFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPayee401kRate extends ModelRow<RowPayee401kRateFields> {
	constructor(values?: Partial<RowPayee401kRateFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPayee401kRateFields {
	calculation_method: string;
	category: string;
	company_id: string;
	contrib_type: string;
	deduct_code_id: string;
	effective_date: Date;
	expire_date: Date;
	id: string;
	on_hold: string;
	unique_id: string;
}

